import React from 'react';
import styled from 'styled-components';
import { Row, Col, Card, List, Input, Tag, Divider } from 'antd';
import { 
  BookOutlined, 
  LinkOutlined, 
  SearchOutlined,
  FileTextOutlined,
  ReadOutlined,
  CodeOutlined,
  RobotOutlined,
  CloudOutlined
} from '@ant-design/icons';
import ComingSoon from '../components/modules/ComingSoon';

const { Search } = Input;

const PageHeader = styled.div`
  background-color: #f0f5ff;
  padding: 3rem 0;
  text-align: center;
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #1d39c4;
`;

const PageDescription = styled.p`
  font-size: 1.1rem;
  max-width: 800px;
  margin: 0 auto;
  color: #666;
`;

const SectionContainer = styled.section`
  padding: 3rem 0;
`;

const SectionTitle = styled.h2`
  margin-bottom: 2rem;
  position: relative;
  
  &:after {
    content: '';
    display: block;
    width: 60px;
    height: 3px;
    background-color: #1890ff;
    margin-top: 0.5rem;
  }
`;

const CategoryCard = styled(Card)`
  height: 100%;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
  
  .ant-card-head-title {
    display: flex;
    align-items: center;
    
    .icon {
      margin-right: 8px;
      font-size: 1.2rem;
    }
  }
`;

const SearchContainer = styled.div`
  max-width: 600px;
  margin: 0 auto 2rem;
`;

const BookCard = styled(Card)`
  margin-bottom: 1.5rem;
  
  .ant-card-cover {
    padding: 1rem 1rem 0;
    background-color: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
  }
  
  .book-icon {
    font-size: 4rem;
    color: #1890ff;
  }
`;

const TagContainer = styled.div`
  margin-top: 1rem;
  
  .ant-tag {
    margin-bottom: 0.5rem;
  }
`;

const Knowledge: React.FC = () => {
  const categories = [
    { title: '技术文档', icon: <FileTextOutlined className="icon" />, count: '整理中' },
    { title: '学习资源', icon: <ReadOutlined className="icon" />, count: '整理中' },
    { title: '编程指南', icon: <CodeOutlined className="icon" />, count: '整理中' },
    { title: 'AI研究', icon: <RobotOutlined className="icon" />, count: '整理中' },
    { title: '在线工具', icon: <CloudOutlined className="icon" />, count: '整理中' },
    { title: '其他资源', icon: <LinkOutlined className="icon" />, count: '整理中' },
  ];
  
  const recommendedBooks = [
    {
      title: '深度学习',
      authors: '伊恩·古德费洛, 约书亚·本吉奥, 亚伦·库维尔',
      tags: ['AI', '机器学习', '深度学习']
    },
    {
      title: 'JavaScript高级程序设计',
      authors: '马特·弗里斯比',
      tags: ['前端', 'JavaScript', '编程']
    },
    {
      title: '代码大全',
      authors: '史蒂夫·迈康奈尔',
      tags: ['编程', '软件工程', '最佳实践']
    }
  ];

  return (
    <>
      <PageHeader>
        <div className="container">
          <PageTitle>知识链接</PageTitle>
          <PageDescription>
            收集整理优质学习资源，分享知识图谱
          </PageDescription>
        </div>
      </PageHeader>
      
      <SectionContainer>
        <div className="container">
          <SearchContainer>
            <Search
              placeholder="搜索资源（功能开发中）"
              enterButton={<SearchOutlined />}
              size="large"
              disabled
            />
          </SearchContainer>
          
          <SectionTitle>资源分类</SectionTitle>
          <Row gutter={[24, 24]}>
            {categories.map((category) => (
              <Col xs={24} sm={12} md={8} key={category.title}>
                <CategoryCard 
                  title={<><span>{category.icon}</span>{category.title}</>}
                  extra={category.count}
                >
                  <ComingSoon 
                    title={`${category.title}整理中`}
                    description="优质资源收集整理中，敬请期待..." 
                  />
                </CategoryCard>
              </Col>
            ))}
          </Row>
        </div>
      </SectionContainer>
      
      <SectionContainer style={{ backgroundColor: '#f5f5f5' }}>
        <div className="container">
          <SectionTitle>推荐书籍</SectionTitle>
          <Row gutter={[24, 24]}>
            {recommendedBooks.map((book) => (
              <Col xs={24} sm={12} md={8} key={book.title}>
                <BookCard
                  cover={
                    <div className="book-icon">
                      <BookOutlined />
                    </div>
                  }
                >
                  <Card.Meta
                    title={book.title}
                    description={`作者: ${book.authors}`}
                  />
                  <TagContainer>
                    {book.tags.map((tag) => (
                      <Tag color="blue" key={tag}>{tag}</Tag>
                    ))}
                  </TagContainer>
                </BookCard>
              </Col>
            ))}
          </Row>
        </div>
      </SectionContainer>
      
      <SectionContainer>
        <div className="container">
          <SectionTitle>知识图谱</SectionTitle>
          <ComingSoon 
            title="知识图谱构建中" 
            description="个人知识体系整理中，即将与您分享..." 
          />
        </div>
      </SectionContainer>
    </>
  );
};

export default Knowledge; 